<div class="container my-24 sm:my-30">
  <div
    class="relative mx-auto flex max-w-lg justify-center rounded-lg p-8 shadow-md ring-1 ring-zinc-900/10 dark:ring-white/10">
    <div class="flex flex-col">
      <h1 class="mb-6 text-center text-2xl font-bold text-zinc-900 uppercase dark:text-zinc-200">
        Login
      </h1>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col items-center gap-3">
        <div>
          <input
            class="rounded-lg border px-3 py-[calc(--spacing(2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
            type="username" id="username" formControlName="username" placeholder="Enter Username" />
        </div>
        <div>
          <input
            class="rounded-lg border px-3 py-[calc(--spacing(2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
            type="password" id="password" formControlName="password" placeholder="Enter Password" />
        </div>
        <div class="relative flex h-6 w-full justify-center">
          <app-embedded-alert [error]="error"></app-embedded-alert>
        </div>
        <button type="submit" [class]="
            loginForm.valid
              ? 'cursor-pointer justify-center rounded-lg bg-zinc-800 px-3 py-2 font-semibold text-zinc-100 outline-offset-2 transition hover:bg-zinc-700 active:bg-zinc-800 active:text-zinc-100/70 active:transition-none'
              : 'cursor-not-allowed justify-center rounded-lg bg-zinc-400 px-3 py-2 font-semibold text-zinc-100 outline-offset-2'
          " [disabled]="!loginForm.valid">
          Login
        </button>
        <div id="recover-password" (click)="goToPasswordRecovery()" class="cursor-pointer text-sm hover:text-cam-navy">
          Forgot Password?
        </div>
      </form>
      <div *ngIf="isLoading" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform">
        <app-loading-spinner></app-loading-spinner>
      </div>
    </div>
  </div>
</div>